






















import { defineComponent, PropType } from '@nuxtjs/composition-api';

import { StaffType } from '@/composables/staff-by-id';

export default defineComponent({
  name: 'WorkerSimple',
  props: {
    staff: {
      type: Array as PropType<StaffType>,
      required: false,
      default: () => [],
    },
    names: {
      type: String,
      required: false,
      default: '',
    },
    role: {
      type: String,
      default: '',
    },
  },
});
